import Icon from '../components/Icon.vue'

Icon.register({"angle-double-left":{"width":448,"height":512,"paths":[{"d":"M223.7 239L359.7 103C369.1 93.6 384.3 93.6 393.6 103L416.2 125.6C425.6 135 425.6 150.2 416.2 159.5L319.9 256 416.3 352.4C425.7 361.8 425.7 377 416.3 386.3L393.7 409C384.3 418.4 369.1 418.4 359.8 409L223.8 273C214.3 263.6 214.3 248.4 223.7 239zM31.7 273L167.7 409C177.1 418.4 192.3 418.4 201.6 409L224.2 386.4C233.6 377 233.6 361.8 224.2 352.5L127.9 256 224.3 159.6C233.7 150.2 233.7 135 224.3 125.7L201.7 103C192.3 93.6 177.1 93.6 167.8 103L31.8 239C22.3 248.4 22.3 263.6 31.7 273z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/angle-double-left.js
// module id = null
// module chunks = 